import { render, staticRenderFns } from "./DocumentImage.vue?vue&type=template&id=241c72cb&scoped=true"
import script from "./DocumentImage.vue?vue&type=script&lang=js"
export * from "./DocumentImage.vue?vue&type=script&lang=js"
import style0 from "./DocumentImage.vue?vue&type=style&index=0&id=241c72cb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "241c72cb",
  null
  
)

export default component.exports